import * as React from 'react';
import Component from '../../../Component';
import Error from '../../../Components/Error';
import Confirm from '../../../Components/Confirm';
import { STATUS } from '../../../General';
import Anchor from '../../../Components/Anchor';
import ChooseYear from '../../../Components/ChooseYear';
import { importHoes, addHoe } from '../../../Actions/Modal';
import * as $ from 'jquery';

export default class List extends Component {

    render() {
        const hoes = this.props.hoes;
        switch (hoes.status) {
            case STATUS.LOADING:
                return this.renderLoading();
            case STATUS.READY: {
                const t = this.translate();
                let trs: any = undefined;
                if (hoes.arr.length === 0) {
                    trs = <tr>
                        <td className="text-danger">
                            {t('no.public.holidays.and.events.found')}
                        </td>
                    </tr>
                } else {
                    trs = hoes.arr.map((hoe: any) => {
                        return <tr key={'Office-Hoe-List' + hoe.id}>
                            <td style={{ width: "65%", maxWidth: '65%', overflowWrap: 'break-word', wordBreak: 'break-word' }}>
                                {hoe.name}
                            </td>
                            <td className="text-right">
                                {hoe.literalDay + ' '} {hoe.formatedDate}
                            </td>
                            <td>
                                <div className="float-right">
                                    <Confirm
                                        title={t('delete')}
                                        className="text-danger text-nowrap"
                                        faIcon="fas fa-trash-alt"
                                        onConfirm={() => {
                                            $.ajax({
                                                type: 'DELETE',
                                                contentType: 'application/json',
                                                url: this.Endpoints().deleteHoe(hoe.id),
                                                dataType: 'json',
                                                cache: false,
                                                success: (data: any, textStatus: any, jqXHR: any) => {
                                                    this.successToastr(t('the.public.holiday.or.event.was.deleted'));
                                                    if (this.props.onRefresh) {
                                                        this.props.onRefresh();
                                                    }
                                                },
                                                error: (jqXHR: any, textStatus: any, errorThrown: any) => {
                                                    this.ajaxError(jqXHR, textStatus, errorThrown);
                                                }
                                            });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                    });
                }
                return <div className={this.getCardClassNameSize()}>
                    <div className="card-body">
                        <table className="table table-sm table-hover w-100 mb-0">
                            <thead>
                                <tr>
                                    <th className="border-top-0" colSpan={3}>
                                        <span className="float-right">
                                            <ChooseYear
                                                currentYear={this.props.currentYear}
                                                years={
                                                    [this.props.currentYear - 1, this.props.currentYear, this.props.currentYear + 1]
                                                }
                                                onChangeYear={(year: any) => {
                                                    if (this.props.onChangeYear) {
                                                        this.props.onChangeYear(year);
                                                    }
                                                }}
                                            />
                                        </span>
                                        <div className="clearfix d-block d-sm-none" />
                                        <div>
                                            <Anchor
                                                title={t('import.public.holidays')}
                                                faIcon="fa fa-cloud"
                                                onClick={() => {
                                                    importHoes(this.getModal(), {
                                                        office: this.props.office,
                                                        callback: () => {
                                                            if (this.props.onRefresh) {
                                                                this.props.onRefresh();
                                                            }
                                                        }
                                                    });
                                                }}
                                            >
                                                {t('import.public.holidays')}
                                            </Anchor>
                                        </div>
                                        <Anchor
                                            faIcon="fa fa-plus"
                                            title={t('add.public.holiday.or.event')}
                                            onClick={() => {
                                                addHoe(this.getModal(), {
                                                    office: this.props.office,
                                                    callback: () => {
                                                        if (this.props.onRefresh) { this.props.onRefresh(); }
                                                    }
                                                });
                                            }}
                                        >
                                            {t('add.public.holiday.or.event')}
                                        </Anchor>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {trs}
                            </tbody>
                        </table>
                    </div>
                </div>
            }
            default:
                return (<Error />);
        }
    }
}